import React from 'react'
import Bidding from '@components/ItemPage/Details/Important/Buttons/Bidding'
import ShareButton from '@components/ItemPage/Details/Important/Buttons/ShareButton'
import Watchlist from '@components/ItemPage/Details/Important/Buttons/Watchlist'
import LastUpdated from '../LastUpdated'

const Buttons = ({
  itemState,
  itemHandler,
  modal,
  auction,
  loadingBid,
  setLoadingBid,
  lastUpdated,
}: any) => {
  return (
    <div className="grid gap-4">
      <Bidding
        itemState={itemState}
        itemHandler={itemHandler}
        modal={modal}
        auction={auction}
        loadingBid={loadingBid}
        setLoadingBid={setLoadingBid}
      />
      <LastUpdated lastUpdated={lastUpdated} />
      <div className="grid gap-4 grid-cols-2">
        <Watchlist />
        <ShareButton />
      </div>
    </div>
  )
}

export default Buttons
